import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/remoteIntentConfirm/:urlId",
    name: "remoteIntentConfirm",
    component: () => import("@/views/proposal/RemoteIntentConfirm.vue")
  },
  {
    path: "/dummy",
    name: "dummy",
    component: () => import("@/views/Dummy.vue")
  },
  {
    path: "/",
    name: "login",
    component: () => import("@/views/Login.vue")
  },
  {
    path: "/mfa",
    name: "mfa",
    component: () => import("@/views/MFA.vue")
  },
  {
    path: "/mypage",
    name: "mypage",
    component: () => import("@/views/mypage/Mypage.vue")
  },
  {
    path: "/groupSchedule",
    name: "groupSchedule",
    component: () => import("@/views/groupSchedule/GroupSchedule.vue")
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/views/dashboard/Dashboard.vue")
  },
  {
    path: "/adminDashboard",
    name: "adminDashboard",
    component: () => import("@/views/dashboard/AdminDashboard.vue")
  },
  {
    path: "/customerSearch",
    name: "customerSearch",
    component: () => import("@/views/customer/CustomerSearch.vue")
  },
  {
    path: "/proposalSearch",
    name: "proposalSearch",
    component: () => import("@/views/proposal/ProposalSearch.vue")
  },
  {
    path: "/customerUnification",
    name: "customerUnification",
    component: () => import("@/views/customer/CustomerUnification.vue")
  },
  {
    path: "/contactSearch",
    name: "contactSearch",
    component: () => import("@/views/contact/ContactSearch.vue")
  },
  {
    path: "/orgSearch",
    name: "orgSearch",
    component: () => import("@/views/org/OrgSearch.vue")
  },
  {
    path: "/intentHearingItem",
    name: "intentHearingItem",
    component: () => import("@/views/masterManage/IntentHearingItem.vue")
  },
  {
    path: "/processDesign",
    name: "processDesign",
    component: () => import("@/views/masterManage/ProcessDesign")
  },
  {
    path: "/userMaster",
    name: "userMaster",
    component: () => import("@/views/masterManage/UserMaster")
  },
  {
    path: "/performanceSummaryReport",
    name: "performanceSummaryReport",
    component: () => import("@/views/report/PerformanceSummaryReport")
  },
  {
    path: "/recommendationReason",
    name: "recommendationReason",
    component: () => import("@/views/masterManage/RecommendationReason.vue")
  },
  {
    path: "/intentConfirmItem",
    name: "intentConfirmItem",
    component: () => import("@/views/masterManage/IntentConfirmItem.vue")
  },
  {
    path: "/branchMaster",
    name: "branchMaster",
    component: () => import("@/views/masterManage/BranchMaster.vue")
  },
  {
    path: "/userPerfomanceGoalMaster",
    name: "userPerfomanceGoalMaster",
    component: () => import("@/views/masterManage/UserPerformanceGoal.vue")
  },
  {
    path: "/branchPerfomanceGoalMaster",
    name: "branchPerfomanceGoalMaster",
    component: () => import("@/views/masterManage/BranchPerfomanceGoal.vue")
  },
  {
    path: "/leakContact",
    name: "leakContact",
    component: () => import("@/views/contact/LeakContact.vue")
  },
  {
    path: "/dailyReportEdit",
    name: "dailyReportEdit",
    component: () => import("@/views/report/DailyReportEdit.vue")
  },
  {
    path: "/dailyReportComment",
    name: "dailyReportComment",
    component: () => import("@/views/report/DailyReportComment.vue")
  },
  {
    path: "/bringoutBook",
    name: "bringoutBook",
    component: () => import("@/views/book/BringoutBook.vue")
  },
  {
    path: "/sendBook",
    name: "sendBook",
    component: () => import("@/views/book/SendBook.vue")
  },
  {
    path: "/receiveBook",
    name: "receiveBook",
    component: () => import("@/views/book/ReceiveBook.vue")
  },
  {
    path: "/recentlyCustomer",
    name: "recentlyCustomer",
    component: () => import("@/views/customer/RecentlyCustomer.vue")
  },
  {
    path: "/recentlyOrg",
    name: "recentlyOrg",
    component: () => import("@/views/org/RecentlyOrg.vue")
  },
  {
    path: "/recruitmentPlanList",
    name: "recruitmentPlanList",
    component: () => import("@/views/recruitment/RecruitmentPlanList.vue")
  },
  {
    path: "/signedContractSummaryReport",
    name: "signedContractSummaryReport",
    component: () => import("@/views/report/SignedContractSummaryReport.vue")
  },
  {
    path: "/policyUpload",
    name: "policyUpload",
    component: () => import("@/views/policy/PolicyUpload.vue")
  },
  {
    path: "/contactSummaryReport",
    name: "contactSummaryReport",
    component: () => import("@/views/report/ContactSummaryReport.vue")
  },
  {
    path: "/cancelSummaryReport",
    name: "cancelSummaryReport",
    component: () => import("@/views/report/CancelSummaryReport.vue")
  },
  {
    path: "/claimSummaryReport",
    name: "claimSummaryReport",
    component: () => import("@/views/report/ClaimSummaryReport.vue")
  },
  {
    path: "/personalInfoBook",
    name: "personalInfoBook",
    component: () => import("@/views/book/PersonalInfoBook.vue")
  },
  {
    path: "/customerKindMaster",
    name: "customerKindMaster",
    component: () => import("@/views/masterManage/CustomerKind.vue")
  },
  {
    path: "/accessLog",
    name: "accessLog",
    component: () => import("@/views/book/AppAccessLog.vue")
  },
  {
    path: "/picNotAssignedTarget",
    name: "picNotAssignedTarget",
    component: () => import("@/views/recruitment/PICNotAssignedTarget.vue")
  },
  {
    path: "/insuranceCorpMaster",
    name: "insuranceCorpMaster",
    component: () => import("@/views/masterManage/InsuranceCorpMaster.vue")
  },
  {
    path: "/recruitmentTargetList",
    name: "recruitmentTargetList",
    component: () => import("@/views/recruitment/RecruitmentPlanTargetList.vue")
  },
  {
    path: "/pathMaster",
    name: "pathMaster",
    component: () => import("@/views/masterManage/Path.vue")
  },
  {
    path: "/contactKindMaster",
    name: "contactKindMaster",
    component: () => import("@/views/masterManage/ContactKind.vue")
  },
  {
    path: "/contactSampleMaster",
    name: "contactSampleMaster",
    component: () => import("@/views/masterManage/ContactSample.vue")
  },
  {
    path: "/orgKindMaster",
    name: "orgKindMaster",
    component: () => import("@/views/masterManage/OrgKind.vue")
  },
  {
    path: "/attachmentKindMaster",
    name: "attachmentKindMaster",
    component: () => import("@/views/masterManage/AttachmentKind.vue")
  },
  {
    path: "/personalInfoKindMaster",
    name: "personalInfoKindMaster",
    component: () => import("@/views/masterManage/PersonalInfoKind.vue")
  },
  {
    path: "/IntentHearingItemMaster",
    name: "IntentHearingItemMaster",
    component: () => import("@/views/masterManage/IntentHearingItem.vue")
  },
  {
    path: "/recommendationReasonMaster",
    name: "recommendationReasonMaster",
    component: () => import("@/views/masterManage/RecommendationReason.vue")
  },
  {
    path: "/intentConfirmItemMaster",
    name: "intentConfirmItemMaster",
    component: () => import("@/views/masterManage/IntentConfirmItem.vue")
  },
  {
    path: "/manual",
    name: "manual",
    component: () => import("@/components/Manual.vue")
  },
  {
    path: "/productMaster",
    name: "productMaster",
    component: () => import("@/views/masterManage/ProductMaster.vue")
  },
  {
    path: "/specialMaster",
    name: "specialMaster",
    component: () => import("@/views/masterManage/SpecialContract.vue")
  },
  {
    path: "/recruitmentTargetExtract",
    name: "recruitmentTargetExtract",
    component: () => import("@/views/recruitment/RecruitmentTargetExtract.vue")
  },
  {
    path: "/CampaignCustomerCategory",
    name: "CampaignCustomerCategory",
    component: () => import("@/views/masterManage/CampaignCustomerCategory.vue")
  },
  {
    path: "/Greeting",
    name: "Greeting",
    component: () => import("@/views/masterManage/Greeting.vue")
  },
  {
    path: "/Letter",
    name: "Letter",
    component: () => import("@/views/masterManage/Letter.vue")
  },
  {
    path: "/IntentConfirmPrint",
    name: "IntentConfirmPrint",
    component: () => import("@/views/proposal/IntentConfirmPrint.vue")
  },
  {
    path: "/CustomerAllInfoPrint",
    name: "CustomerAllInfoPrint",
    component: () => import("@/views/customer/CustomerAllInfoPrint.vue")
  },
  {
    path: "/OrgAllInfoPrint",
    name: "OrgAllInfoPrint",
    component: () => import("@/views/org/OrgAllInfoPrint.vue")
  },
  {
    path: "/OrgSecondThirdLevelInfoPrint",
    name: "OrgSecondThirdLevelInfoPrint",
    component: () => import("@/views/org/OrgSecondThirdLevelInfoPrint.vue")
  },
  {
    path: "/fileDownloadLog",
    name: "FileDownloadLog",
    component: () => import("@/views/book/FileDownloadLog.vue")
  },
  {
    path: "/performanceManagementReport",
    name: "PerformanceManagementReport",
    component: () => import("@/views/report/PerformanceManagementReport.vue")
  },
  {
    path: "/suitabilityItem",
    name: "SuitabilityItem",
    component: () => import("@/views/masterManage/SuitabilityItem.vue")
  },
  {
    path: "/policySearch",
    name: "policySearch",
    component: () => import("@/views/policy/PolicySearch.vue")
  },
  {
    path: "/tNetContractItemDataUpload",
    name: "tNetContractItemDataUpload",
    component: () => import("@/views/policy/TNetContractItemDataUpload.vue")
  },
  {
    path: "/intentConfirmSearch",
    name: "IntentConfirmSearch",
    component: () => import("@/views/proposal/IntentConfirmSearch.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to && from && from.name !== to.name) {
    window.scrollTo({ top: 0 });
  }
  let user = store.state.user;
  //console.log(user.userName);
  const printPath = [
    "/IntentConfirmPrint",
    "/CustomerAllInfoPrint",
    "/OrgAllInfoPrint",
    "/OrgSecondThirdLevelInfoPrint"
  ];
  if (
    (user === null || user.userName === "") &&
    to.path !== "/" &&
    !printPath.includes(to.path) &&
    to.path.startsWith("/remoteIntentConfirm") == false
  ) {
    router.replace("/");
    return false;
  }

  // 印刷ページ脆弱性対応
  if (printPath.includes(to.path) && !localStorage.getItem(to.path)) {
    router.replace("/");
    return false;
  }

  next();
});

export default router;
